import React, { Fragment } from "react";
import MultiSelect from "components/Form/fields/MultiSelect";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import get from "lodash/get";
import { STATE_KEYS } from "utils/constants/state";
import ZoneLink from "components/ZoneLink";
import { STRIPE_EDUCATION } from "constants/education";
import { DOCS_ZONE_LINK } from "constants/docs";
import { useFormikContext } from "formik";
import {
  TAX_ID_COLLECTION_TYPE,
  TAX_ID_COLLECTION_TYPE_LABEL,
  TAX_ID_COLLECTION_TYPE_OPTIONS
} from "utils/constants/taxRate";
import TaxIdTypeOption from "components/TaxIdTypeOption";
import startCase from "lodash/startCase";

const TaxIdCollectionType = (props) => {
  const options =
    props && props.options ? props.options : TAX_ID_COLLECTION_TYPE_OPTIONS;
  const {
    values,
    setFieldValue,
    touched,
    setFieldTouched
  } = useFormikContext();
  const hasInternational = Boolean(
    Array.isArray(options) &&
      options.find(({ id }) => id === TAX_ID_COLLECTION_TYPE.INTERNATIONAL)
  );
  const canEdit = !Boolean(values.id);
  const active = get(values, STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_ENABLED);

  const coverageNotes = [STRIPE_EDUCATION.TAX_ID_COLLECTION.disclaimer];
  if (hasInternational) {
    coverageNotes.push(STRIPE_EDUCATION.TAX_ID_COLLECTION.international);
  }
  const taxIdCollectionType = get(
    values,
    STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_TYPE
  );

  const taxIdSelectProps = {
    value: taxIdCollectionType
      ? [
          {
            id: taxIdCollectionType,
            name: `${startCase(taxIdCollectionType)} - ${
              TAX_ID_COLLECTION_TYPE_LABEL[taxIdCollectionType]
            }`
          }
        ]
      : [],
    placeholder: "Select type of tax id collection",
    isMulti: false,
    disabled: !canEdit,
    options,
    onChange: () => ({ value }) => {
      if (!get(touched, STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_TYPE)) {
        setFieldTouched(STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_TYPE, true);
      }

      setTimeout(
        () =>
          setFieldValue(STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_TYPE, value),
        0
      );
    },
    labelTransform: (value) => value,
    components: {
      Option: TaxIdTypeOption
    }
  };

  return (
    <Fragment>
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-column w-100">
          <div className="flex flex-row items-center justify-between">
            <label className="f5 fw6 db">
              {STRIPE_EDUCATION.TAX_ID_COLLECTION.title}
            </label>
            <Toggle
              {...getToggleProps({
                active,
                disabled: !canEdit,
                setFieldValue: (_, updatedActive) => {
                  if (
                    !get(
                      touched,
                      STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_ENABLED
                    )
                  ) {
                    setFieldTouched(
                      STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_ENABLED,
                      true
                    );
                  }

                  setTimeout(
                    () =>
                      setFieldValue(
                        STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_ENABLED,
                        updatedActive
                      ),
                    0
                  );
                }
              })}
            />
          </div>
          <div className="f6 pt2 lh-copy">
            {STRIPE_EDUCATION.TAX_ID_COLLECTION.checkout}
          </div>
        </div>
      </div>
      {active && (
        <div className="pt3">
          <div className="flex flex-column">
            <label className="f6 fw6 db pb2">Coverage</label>
            <MultiSelect {...taxIdSelectProps} />
            <div className="flex flex-column mt3">
              <div className="f6 lh-copy word-break">
                {coverageNotes.join(" ")}
              </div>
              <div className="pt2">
                <ZoneLink
                  href={DOCS_ZONE_LINK.LEARN_PAYMENT_LINKS_OVERVIEW}
                  zone
                  linkProps={{
                    className: "link",
                    target: "_blank"
                  }}
                >
                  <div className="f6 fw6 link__decoration--hover color-primary pointer">
                    Learn more
                  </div>
                </ZoneLink>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default TaxIdCollectionType;
